import Button from './Button';

const Icon = () => {
  return Button({ className: 'ecodigo-ckm-icon', content: 'icon' });
};

export default Icon;
